import type { PaymentTransaction } from "../../domain/entities/PaymentTransaction";
import type { OrderId } from "../../domain/value-objects/OrderId";
import type { PaymentTransactionQueryPort } from "../ports/PaymentTransactionQueryPort";

export class GetLatestTransactionByReferenceCodeUseCase {
  constructor(private readonly transactionQueryPort: PaymentTransactionQueryPort) {}

  async execute(referenceCode: OrderId): Promise<PaymentTransaction | null> {
    return this.transactionQueryPort.findLatestByReferenceCode(referenceCode);
  }
}
